export const TOOLTIP_INVERTED_ENTITY_BADGE_CLASS = 'tooltip-inverted-entity-badge';

export const ENTITY_BADGE_LEADING_ICON_CLASS = 'entity-badge-leading-icon';
export const ENTITY_BADGE_EXTERNAL_LINK_CLASS = 'entity-badge-external-link';
